module.exports = __webpack_public_path__ + "static/media/ku_hraswo.fa9fe0b2.ogg";